import React from "react";
import {connect} from "redux-bundler-react";
import {Row, Col, NavDropdown} from "react-bootstrap";
import {FiExternalLink} from 'react-icons/fi'
import panSites from '../conf';
import {NavLink} from 'react-router-dom';
import VideoGallery from "gramene-videos";

const tools = {
  browser: {
    title: "Genome Browser",
    description: "Genome annotations, variation and comparative tools",
    ensemblPath: "/index.html",
    imgSrc: "static/images/welcome/ensemblgramene.png"
  },
  reactome: {
    title: "Plant Reactome",
    description: "Browse and analyze metabolic and regulatory pathways",
    link: "//plantreactome.gramene.org",
    imgSrc: "static/images/welcome/plantReactome.svg",
    isExternal: true
  },
  tools: {
    title: "Ensembl Tools",
    description: "Tools for fetching and searching genomic data",
    ensemblPath: "/tools.html",
    imgSrc: "static/images/welcome/tools.png"
  },
  atlas: {
    title: "Plant Expression Atlas",
    description: "Browse plant expression results at EBI",
    link: "//www.ebi.ac.uk/gxa/plant/experiments",
    imgSrc: "static/images/welcome/ExpressionAtlas.png",
    isExternal: true
  },
  blast: {
    title: "BLAST",
    description: "Query our genomes with a DNA or protein sequence",
    ensemblPath: "/Tools/Blast?db=core",
    imgSrc: "static/images/welcome/BLAST.png"
  },
  mart: {
    title: "Gramene Mart",
    description: "An advanced genomic query interface powered by BioMart",
    ensemblPath: "/biomart/martview",
    imgSrc: "static/images/welcome/Biomart250.png"
  },
  EG_mart: {
    title: "Ensembl Plants Mart",
    description: "An advanced genomic query interface powered by BioMart",
    link: "https://plants.ensembl.org/biomart/martview",
    imgSrc: "static/images/welcome/Biomart250.png",
    isExternal: true
  },
  trackhub: {
    title: "Track Hub Registry",
    description: "A global centralised collection of publicly accessible track hubs",
    link: "//trackhubregistry.org",
    imgSrc: "static/images/welcome/TrackHub.png",
    isExternal: true
  },
  outreach: {
    title: "Outreach and Training",
    description: "Education resources and webinars",
    drupalLink: "outreach",
    imgSrc: "static/images/welcome/noun_553934.png"
  },
  downloads: {
    title: "Bulk Downloads",
    description: "FTP download of our data",
    drupalLink: "ftp-download",
    imgSrc: "static/images/welcome/download.png"
  },
  ftp: {
    title: "Bulk Downloads",
    description: "FTP download of our data",
    link: "ftp",
    imgSrc: "static/images/welcome/download.png"
  },
  archive: {
    title: "Archive",
    description: "Legacy tools and data (markers, Cyc pathways, etc)",
    drupalLink: "archive",
    imgSrc: "static/images/welcome/archive.jpg"
  },
  climtools: {
    title: "CLIMtools",
    description: "Environment x Genome x Phenotype Associations",
    link: "https://www.gramene.org/CLIMtools",
    imgSrc: "static/images/welcome/climtools.png"
  },
  oryzaclimtools: {
    title: "CLIMtools",
    description: "Environment x Genome x Phenotype Associations",
    link: "https://gramene.org/CLIMtools/oryza_19K-RGP/",
    imgSrc: "static/images/welcome/climtools.png"
  },
  oryzadownloads: {
    title: "Bulk Downloads",
    description: "FTP download of our data",
    link: "https://ftp.gramene.org/oryza/19K-RGP/",
    imgSrc: "static/images/welcome/download.png"
  },
  maizedownloads: {
    title: "Bulk Downloads",
    description: "FTP download of our data",
    link: "https://ftp.gramene.org/maize/release-current/",
    imgSrc: "static/images/welcome/download.png"
  },
  maizegdb: {
    title: "MaizeGDB",
    description: "Maize Genetics and Genomics Database",
    link: "https://maizegdb.org/",
    imgSrc: "static/images/welcome/maize/maizegdb.png",
    isExternal: true
  },
  pansites: {
    title: "Plant Pan Genomes",
    description: "Gramene-powered sites focused on specific crops",
    link: "pansites",
    imgSrc: "static/images/welcome/pangenomes.svg"
  },
  curated: {
    title: "Curated Gene Function",
    description: "Genes described in the literature",
    link: "?fq_field=capabilities&fq_value=pubs&category=Curated&name=publication",
    imgSrc: "static/images/welcome/curated.png"
  },
  tutorials: {
    title: "Video Tutorials",
    description: "Site features, explained!",
    link: "https://www.youtube.com/@sorghumbase9338",
    imgSrc: "static/images/welcome/tutorials.png",
    isExternal: true
  },
  videotutorials: {
    title: "Video Tutorials",
    description: "Site features, explained!",
    link: 'videotutorials',
    imgSrc: "static/images/welcome/tutorials.png"
  }
};

const GrameneTool = ({title, description, imgSrc, imgSrc2, link, drupalLink, ensemblPath, isExternal, ensemblURL, id, version}) => {
  let external;
  if (isExternal) {
    external = <small title="This link opens a page from an external site" style={{float:'right'}}><FiExternalLink/></small>;
  }
  if (!link) {
    if (drupalLink) {
      link = drupalLink;
    }
    if (ensemblPath) {
      link = ensemblURL + ensemblPath;
    }
  }
  else {
    if (link === 'pansites') {
      return (
        <NavLink to="/pansites" style={{textDecoration:'none'}}>
          <Col>
            <Row className="gramene-tool">
              <Col md="auto">
                <img style={{width: "96px"}} src={imgSrc} alt={title}/>
              </Col>
              <Col>
                <h5 style={{color:'#212529'}}>
                  {title}{external}
                </h5>
                <p className="gramene-tool-desc">{description}</p>
              </Col>
            </Row>
          </Col>
        </NavLink>
      )
    }
    if (link === 'ftp') {
      link = `https://ftp.gramene.org/${id}/${version}`
    }
  }
  return (
    <Col onClick={() => isExternal ? window.open(link, '_blank') : window.location.href = link}>
      <Row className="gramene-tool">
        <Col md="auto">
          <img style={{width: "96px"}} src={imgSrc} alt={title}/>
        </Col>
        <Col>
          <h5>
            {title}{external}
          </h5>
          <p className="gramene-tool-desc">{description}</p>
        </Col>
      </Row>
    </Col>
  );
};

const GrameneToolLink = ({title, description, imgSrc, link, drupalLink, ensemblPath, isExternal, ensemblURL, id, version}) => {
  let external;
  if (isExternal) {
    external = <small title="This link opens a page from an external site"><FiExternalLink/></small>;
  }
  if (!link) {
    if (drupalLink) {
      link = drupalLink;
    }
    if (ensemblPath) {
      link = ensemblURL + ensemblPath;
    }
  }
  else {
    if (link === 'ftp') {
      link = `https://ftp.gramene.org/${id}/${version}`
    }
  }
  return <NavDropdown.Item href={link}><img style={{width: "32px"}} src={imgSrc}/>&nbsp;&nbsp;{title}</NavDropdown.Item>
};

const PortalsCmp = props => (
  <div className="tools-wrapper">
    {props.location && props.location.pathname === '/pansites' && <h3>Plant Pan Genome sites</h3>}
    {props.location && props.location.pathname === '/videotutorials' && <h3>Tutorial Videos</h3>}
    {props.location && props.location.pathname === '/pansites' ?
      <Row xs={1} md={2} className="g-4">
        {panSites.filter(site => site.id !== props.configuration.id && site.showInMenu).map((site, idx) =>
          <Col key={idx} onClick={() => window.location.href = site.url}>
            <Row className="gramene-tool">
              <Col md="auto">
                <img style={{width:"165px"}} src={`static/images/${site.id}_logo.svg`}/>
              </Col>
              <Col>
                {/*<h5>{site.name}&nbsp;{site.version}</h5>*/}
                <p className="gramene-tool-desc">{site.description}</p>
              </Col>
            </Row>
          </Col>
        )}
      </Row>
      :
      <div>{props.location && props.location.pathname === '/videotutorials' ? <VideoGallery playlistIds={props.configuration.playlistIds}/> :
        <Row xs={1} md={2} xxl={3} className="g-4">
          {props.configuration.portals.map((portal, idx) =>
              <GrameneTool {...tools[portal]} key={idx} ensemblURL={props.configuration.ensemblURL}
                           id={props.configuration.id} version={props.configuration.version}/>
          )}
        </Row>
      }</div>
    }
  </div>
);

export const Portals = connect(
  'selectConfiguration',
  PortalsCmp
);

const PortalsDropdownCmp = ({configuration}) => {
  if (configuration.portals2) {
    return (
      <NavDropdown id={'portals-dropdown'} title={'Links'} className={"dropup"}>
        { configuration.portals2.map((portal, idx) =>
          <GrameneToolLink {...tools[portal]} key={idx} ensemblURL={configuration.ensemblURL} id={configuration.id} version={configuration.version}/>
        )}
      </NavDropdown>
    )
  }
}

export const PortalsDropdown = connect(
  'selectConfiguration',
  PortalsDropdownCmp
);

const ExamplesCmp = props => {
  return (
    <div className="examples-wrapper">
      <h3>Examples</h3>
      <Row xs={1} md={2} xl={2} className="g-4">
        {props.configuration.examples.map((example, idx) =>
          <Col key={idx} onClick={() => window.location.href = example.link}>
            <Row className="gramene-example">
              <Col md="auto">
                <img src={example.imgSrc} alt={example.title}/>
              </Col>
              <Col>
                <h5>
                  {example.title}
                </h5>
                <p className="gramene-example-desc">{example.description}</p>
              </Col>
            </Row>
          </Col>
        )}
      </Row>
    </div>
  )
};
export const Examples = connect(
  'selectConfiguration',
  ExamplesCmp
);
